import CopiableTag from "common/components/CopiableTag";
import MobileDetailsDrawer from "common/components/MobileDetailsDrawer";
import MobileDetailsDrawerItem from "common/components/MobileDetailsDrawer/MobileDetailsDrawerItem";
import { DrawerHeader } from "common/components/ui/Drawer";

import { API_KEYS_ACTIONS } from "../../../constants";
import { formatBillingDate } from "../../../utils";
import ApiKeyActions from "../ApiKeyActions";

import type { ApiToken } from "../../../types";

interface TokenDetailsProps {
  selectedToken: ApiToken;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export default function TokenDetails({
  selectedToken,
  isOpen,
  setIsOpen,
}: TokenDetailsProps) {
  const {
    name,
    token: tokenId,
    created_at: createdAt,
    write: canWrite,
    read: canRead,
  } = selectedToken;

  return (
    <MobileDetailsDrawer
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      editOptions={API_KEYS_ACTIONS}
      renderEditComponent={(editKey, onBack) => (
        <ApiKeyActions
          token={selectedToken}
          action={editKey}
          onClose={() => setIsOpen(false)}
          onBack={onBack}
        />
      )}
      editTitle="API key options"
    >
      <DrawerHeader title={name} />
      <MobileDetailsDrawerItem label="Permissions">
        {canWrite && canRead ? "All" : "Read only"}
      </MobileDetailsDrawerItem>
      <MobileDetailsDrawerItem label="Key">
        <CopiableTag value={tokenId} />
      </MobileDetailsDrawerItem>
      <MobileDetailsDrawerItem label="Created at">
        {formatBillingDate(createdAt)}
      </MobileDetailsDrawerItem>
    </MobileDetailsDrawer>
  );
}
